// Fixed Tailwind-safe palette, same reasoning as widgetIcons.js -- Tailwind's
// JIT compiler only includes classes it can see as literal strings in source,
// so a color coming from data (page_widgets.props_json) can't be turned into
// an arbitrary `bg-${color}-600` string. Every color widget data can select
// is enumerated here once, each with a light badge variant (icon/accent use)
// and a solid variant (hero backgrounds, filled buttons).
export const WIDGET_COLORS = {
  blue: { bg: "bg-blue-100", text: "text-blue-700", border: "border-blue-200", solid: "bg-blue-600", solidText: "text-white" },
  green: { bg: "bg-green-100", text: "text-green-700", border: "border-green-200", solid: "bg-green-600", solidText: "text-white" },
  orange: { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-200", solid: "bg-orange-600", solidText: "text-white" },
  red: { bg: "bg-red-100", text: "text-red-700", border: "border-red-200", solid: "bg-red-600", solidText: "text-white" },
  purple: { bg: "bg-purple-100", text: "text-purple-700", border: "border-purple-200", solid: "bg-purple-600", solidText: "text-white" },
  teal: { bg: "bg-teal-100", text: "text-teal-700", border: "border-teal-200", solid: "bg-teal-600", solidText: "text-white" },
  gray: { bg: "bg-gray-100", text: "text-gray-700", border: "border-gray-200", solid: "bg-gray-800", solidText: "text-white" },
};

export const resolveWidgetColor = (name) => WIDGET_COLORS[name] || WIDGET_COLORS.gray;
